/* @ngInject */
function businessDataService (ConnectorWebService, CONSTANTS, Utils, $q) {
  var cacheBusinessData = []

  var service = {
    getAllBusinessDataService,
    getBusinessDataByUserId,
    getBusinessDataById,
    getBusinessDataByContextId,
    createNewPlaceholder,
    editBusinessData,
    getAllBusinessDataFieldsForEditor,
    getCompanyBusinessDataService,
    getBusinessDataService,
    getBusinessDataServiceByUser,
    deleteBusinessDataField,
    getBusinessDataFieldsCache
  }
  return service

  function getAllBusinessDataService () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_DATA)
  }

  function getBusinessDataService () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_DATA_FIELD)
  }

  function getBusinessDataServiceByUser (userId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_FIELD_ID, [userId])
    return ConnectorWebService.get(url)
  }

  function getCompanyBusinessDataService () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_DATA_COMPANY)
  }

  function getBusinessDataByUserId (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_ID_USER, [id])
    return ConnectorWebService.get(url)
  }

  function getBusinessDataById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_ID, [id])
    return ConnectorWebService.get(url)
  }

  function getBusinessDataByContextId (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_CONTEXTS_ID_BUSINESS_DATA_FIELDS, [id])
    return ConnectorWebService.get(url)
  }

  function createNewPlaceholder (data) {
    return ConnectorWebService.post(CONSTANTS.URL_BUSINESS_DATA, data)
  }

  function editBusinessData (data) {
    return ConnectorWebService.put(CONSTANTS.URL_BUSINESS_DATA, data)
  }

  function deleteBusinessDataField (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_DATA_FIELD_ID, [id])
    return ConnectorWebService.fnDelete(url)
  }

  function getAllBusinessDataFieldsForEditor () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_PLACEHOLDERS)
  }

  function getBusinessDataFieldsCache () {
    if (cacheBusinessData.length === 0) {
      cacheBusinessData = $q.resolve(service.getAllBusinessDataFieldsForEditor())
      return cacheBusinessData
    } else {
      return cacheBusinessData
    }
  }
}

export { businessDataService }
